import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';
import { MySpaceService } from '../my-space.service';

@Component({
  selector: 'app-course-permissions-requests',
  templateUrl: './course-permissions-requests.component.html',
  styleUrls: ['./course-permissions-requests.component.scss'],
  standalone: false,
})
export class CoursePermissionsRequestsComponent implements OnInit, OnDestroy {
  requests = [];
  translateSub: Subscription;
  storage;
  userTypes = [
    { name: 'Administrateur', value: 'Admin' },
    { name: 'Créateur', value: 'Writer' },
    { name: 'Lecteur', value: 'Reader' },
  ];
  role = 'Reader';

  constructor(
    private mySpaceService: MySpaceService,
    private confirmService: AppConfirmService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.storage = inject(Storage);

    this.translateSub = this.translate.onLangChange.subscribe((res) => {
      this.getCoursesTranslatedNames();
    });
    this.translate.onLangChange.subscribe((res) => this.translateOptions());
  }

  ngOnInit() {
    this.getRequests();
    this.translateOptions();
  }

  ngOnDestroy() {
    this.translateSub.unsubscribe();
  }

  async getDownloadURL(url) {
    try {
      const reference = ref(this.storage, url);
      return await getDownloadURL(reference);
    } catch (error) {
      return 'assets/images/no_user.png';
    }
  }

  translateOptions() {
    this.userTypes.map((e) => {
      e.name = this.translate.instant(`Group.${e.value}`);
    });
  }

  getCoursesTranslatedNames() {
    this.requests = this.requests.map((request) => {
      if (request.courseName) {
        request.actualName = (request.courseName.find((edition) => edition.language == this.translate.currentLang) || {}).content;
      }
      if (request.courseDescription) {
        request.actualDescription = (request.courseDescription.find((edition) => edition.language == this.translate.currentLang) || {}).content;
      }
      return request;
    });
  }

  getRequests() {
    this.mySpaceService.getCoursePermissions().subscribe(async (requests) => {
      for (const e of requests) {
        e.requester.photo = e.requester.photo ? await this.getDownloadURL(e.requester.photo) : 'assets/images/no_user.png';
      }

      this.requests = requests.map((e) => {
        e.role = 'Reader';
        return e;
      });
      this.getCoursesTranslatedNames();
    });
  }

  openElementURL(courseID) {
    this.router.navigateByUrl(`/knowledge/overview/${courseID}`);
  }

  acceptRequest(request) {
    const requestID = request._id;
    const role = request.role;

    this.confirmService.confirm({ message: this.translate.instant('Confirm.AcceptRequest') }).subscribe((res) => {
      if (res) {
        this.mySpaceService.acceptCourseRequest({ requestID, role }).subscribe((res) => {
          this.getRequests();
        });
      }
    });
  }

  rejectRequest(requestID) {
    this.confirmService.confirm({ message: this.translate.instant('Confirm.RejectRequest') }).subscribe((res) => {
      if (res) {
        this.mySpaceService.rejectCourseRequest({ requestID }).subscribe((res) => {
          this.getRequests();
        });
      }
    });
  }
}
